// au disabled delivery dates for region state
export const DISABLED_DELIVERY_DATES = {
  NSW: [
    {
      from: '2024-12-06',
      to: '2025-01-12',
    },
  ],
  VIC: [
    {
      from: '2024-12-06',
      to: '2025-01-15',
    },
  ],
  SA: [
    {
      from: '2024-12-06',
      to: '2025-01-15',
    },
  ],
  QLD: [
    {
      from: '2024-12-06',
      to: '2025-01-12',
    },
  ],
  WA: [
    {
      from: '2024-12-06',
      to: '2025-01-21',
    },
  ],
};

export const DISABLED_DELIVERY_DATES_STATES = ['NSW', 'VIC', 'SA', 'QLD', 'WA'];
